import forOwn from 'lodash/forOwn';

const config = {};

forOwn(process.env, (value, key) => {
    if (key.indexOf('VUE_APP_') !== -1) {
        const configKey = key.replace('VUE_APP_', '');
        config[configKey] = value;
    } else {
        config[key] = value;
    }
});

export default config;

